export const AUTH_REF = 'pocket-pathologist/auth-ref';
export const CONTACT_FORM_SUBMITTED =
  'pocket-pathologist/contact-form-submitted';
export const NOTIF_PROMPT = 'pocket-pathologist/notifications-prompt';
